import { render, staticRenderFns } from "./CustomerPlans.vue?vue&type=template&id=45ba3984"
import script from "./CustomerPlans.vue?vue&type=script&lang=js"
export * from "./CustomerPlans.vue?vue&type=script&lang=js"
import style0 from "./CustomerPlans.vue?vue&type=style&index=0&id=45ba3984&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports